import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalService, ModalSize } from '@/core/modal/modal.service';

function sizeClass(size: ModalSize): string {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'lg':
      return 'max-w-xl';
    case 'xl':
      return 'max-w-2xl';
    case '2xl':
      return 'max-w-4xl';
    case 'full':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
}

@Component({
  selector: 'dialab-modal-outlet',
  imports: [NgComponentOutlet, CdkTrapFocus, TranslocoPipe],
  templateUrl: './modal-outlet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(document:keydown.escape)': 'onEscape()' },
})
export class ModalOutlet {
  protected readonly service = inject(ModalService);
  protected readonly modal = this.service.activeModal;

  protected readonly wrapperClass = computed(() => {
    const size = this.modal()?.options.size ?? 'md';
    return `pointer-events-auto mx-auto w-full ${sizeClass(size)}`;
  });

  protected onBackdropClick(): void {
    const m = this.modal();
    if (m && m.options.backdropDismissable !== false) {
      m.ref.dismiss();
    }
  }

  protected onEscape(): void {
    const m = this.modal();
    if (m && m.options.backdropDismissable !== false) {
      m.ref.dismiss();
    }
  }
}
